import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import CostTracking from './components/CostTracking';
import CreateProject from './components/CreateProject';
import EditProject from './components/EditProject';
import LandingPage from './components/LandingPage';
import Subcontractors from './components/Subcontractors';
import { AuthProvider } from './contexts/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import AdminApproval from './components/AdminApproval';
import Dashboard from './components/Dashboard';
import Timesheet from './components/Timesheet';
import Commissioning from './components/Commissioning';
import UpdateRole from './components/UpdateRole';
import TodoList from './components/TodoList';
import CISTracker from './components/CISTracker';
import './styles/App.css';

function AppContent() {
  const location = useLocation();

  // If we're on the landing page, render it without the navigation
  if (location.pathname === '/') {
    return <LandingPage />;
  }

  return (
    <div>
      <Routes>
        <Route path="/dashboard" element={
          <PrivateRoute>
            <Dashboard />
          </PrivateRoute>
        } />
        <Route path="/projects" element={
          <PrivateRoute allowedRoles={['project_manager', 'admin', 'director']}>
            <CostTracking />
          </PrivateRoute>
        } />
        <Route path="/create-project" element={
          <PrivateRoute allowedRoles={['project_manager', 'admin', 'director']}>
            <CreateProject />
          </PrivateRoute>
        } />
        <Route path="/edit-project/:projectId" element={
          <PrivateRoute allowedRoles={['project_manager', 'admin', 'director']}>
            <EditProject />
          </PrivateRoute>
        } />
        <Route path="/subcontractors" element={
          <PrivateRoute allowedRoles={['project_manager', 'admin', 'director']}>
            <Subcontractors />
          </PrivateRoute>
        } />
        <Route path="/cis" element={
          <PrivateRoute allowedRoles={['project_manager', 'admin', 'director']}>
            <CISTracker />
          </PrivateRoute>
        } />
        <Route path="/admin-approval" element={
          <PrivateRoute allowedRoles={['director']}>
            <AdminApproval />
          </PrivateRoute>
        } />
        <Route path="/timesheet" element={
          <PrivateRoute>
            <Timesheet />
          </PrivateRoute>
        } />
        <Route path="/commissioning" element={
          <PrivateRoute>
            <Commissioning />
          </PrivateRoute>
        } />
        <Route path="/todo" element={
          <PrivateRoute>
            <TodoList />
          </PrivateRoute>
        } />
        <Route path="/update-role" element={
          <PrivateRoute allowedRoles={['director']}>
            <UpdateRole />
          </PrivateRoute>
        } />
      </Routes>
    </div>
  );
}

function App() {
  return (
    <Router>
    <AuthProvider>
        <AppContent />
      </AuthProvider>
      </Router>
  );
}

export default App;
